import { useFavicon } from 'react-use';

const useChangeHeadProperties = (title: string, favicon: string) => {
  useFavicon(favicon);
  document.title = title;
};
export default useChangeHeadProperties;
